"use strict";
exports.__esModule = true;
var Promise = require("bluebird");
var errors = require("../../errors");
var guards_1 = require("../../guards");
var types_1 = require("../../types");
/**
 * @method createGetInclusionStates
 *
 * @memberof module:core
 *
 * @param {Provider} provider - Network provider for accessing IRI
 *
 * @return {function} {@link #module_core.getInclusionStates `getInclusionStates`}
 */
exports.createGetInclusionStates = function (_a) {
    var send = _a.send;
    /**
     * Fetches inclusion states of given list of transactions, by calling
     * [`getInclusionStates`](https://docs.iota.works/iri/api#endpoints/getInclusionsStates) command.
     *
     * @example
     * ```js
     * getInclusionStates(transactions)
     *   .then(states => {
     *     // ...
     *   })
     *   .catch(err => {
     *     // ...
     *   })
     * ```
     *
     * @method getInclusionStates
     *
     * @memberof module:core
     *
     * @param {Hash[]} transactions - List of transaction hashes
     * @param {Hash[]} tips - List of tips to check if transactions are referenced by
     * @param {Callback} [callback] - Optional callback
     *
     * @return {Promise}
     * @fulfil {boolean[]} Array of inclusion state
     * @reject {Error}
     * - `INVALID_TRANSACTION_HASH`: Invalid `hashes` or `tips`
     * - Fetch error
     */
    return function (transactions, tips, callback) {
        return Promise.resolve(guards_1.validate(guards_1.arrayValidator(guards_1.hashValidator)(transactions, errors.INVALID_TRANSACTION_HASH), guards_1.arrayValidator(guards_1.hashValidator)(tips, errors.INVALID_TRANSACTION_HASH)))
            .then(function () {
            return send({
                command: types_1.IRICommand.GET_INCLUSION_STATES,
                transactions: transactions,
                tips: tips
            });
        })
            .then(function (_a) {
            var states = _a.states;
            return states;
        })
            .asCallback(callback);
    };
};
//# sourceMappingURL=createGetInclusionStates.js.map